// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"295":"9675a971","453":"24e4d4ef"}[chunkId] + ".chunk.js";
};